const PLAYER_TRACKS_EVENTS = {
  SET_URL_PLAYBACK: "setUrlPlayback",
  SET_AVAILABLE_AUDIO_LANGUAGES: "setAvailableAudioLanguages",
  SET_AVAILABLE_SUBTITLE_TRACKS: "setAvailableSubtitleTracks",
  SET_CURRENT_BITRATE: "setCurrentBitRate",
  SET_AVAILABLE_VIDEO_BITRATES: "setAvailableVideoBitRates"
};
const AUDIO_LANGUAGE_NOT_AVAILABLE = "undetermined";
const KEY_SYSTEM_NAMES = {
  widevine: "com.widevine.alpha",
  playready: "com.microsoft.playready"
};
const DEFAULT_SEEK_THRESHOLD_MULTIPLIER = 2;
const DEFAULT_CATCHUP_PLAYBACK_RATE = 1.05;
const DEFAULT_FALLBACK_PLAYBACK_RATE = 0.95;
const PlayerRequestType = {
  MANIFEST: "MANIFEST",
  SEGMENT: "SEGMENT",
  LICENSE: "LICENSE",
  APP: "APP",
  TIMING: "TIMING",
  SERVER_CERTIFICATE: "SERVER_CERTIFICATE",
  KEY: "KEY",
  ADS: "ADS",
  OTHER: "OTHER"
};

export { AUDIO_LANGUAGE_NOT_AVAILABLE, DEFAULT_CATCHUP_PLAYBACK_RATE, DEFAULT_FALLBACK_PLAYBACK_RATE, DEFAULT_SEEK_THRESHOLD_MULTIPLIER, KEY_SYSTEM_NAMES, PLAYER_TRACKS_EVENTS, PlayerRequestType };
//# sourceMappingURL=constants.js.map
